import { useState } from "react";
import { FiUpload, FiCheck, FiX } from "react-icons/fi";
import { readFileAsync } from "@/utils";
import { useComponentTranslation } from "@/services/i18n";

const translations = {
  en: {
    resume_upload: "Upload resume",
    error_pdf_only: "Please upload a PDF file only",
    error_read_failed: "Failed to read file. Please try again.",
  },
  fr: {
    resume_upload: "Télécharger le CV",
    error_pdf_only: "Veuillez télécharger uniquement un fichier PDF",
    error_read_failed: "Échec de la lecture du fichier. Veuillez réessayer.",
  },
};

export default function ResumeField({ visibleFields, value, setValue, showValidation }) {
  const { t } = useComponentTranslation(translations);
  const [fileName, setFileName] = useState("");
  const field = visibleFields.find((f) => f.id === "resume");
  if (!field) return null;

  const isMandatory = field.mandatory === true;
  const isEmpty = !value && !fileName;
  const showError = showValidation && isMandatory && isEmpty;

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.type !== "application/pdf") {
      alert(t("error_pdf_only"));
      return;
    }

    try {
      const rawBody = await readFileAsync(file);
      setValue(rawBody);
      setFileName(file.name);
    } catch (e) {
      console.error("Error reading file:", e);
      alert(t("error_read_failed"));
    }
  };

  return (
    <div className="flex flex-col">
      <label htmlFor={field.id} className="input-label">
        {field.label} {isMandatory && "*"}
      </label>
      <input type="file" id={field.id} accept=".pdf" onChange={handleFileChange} className="hidden" />
      {fileName ? (
        <div className="flex items-center gap-2 px-4 h-10 border border-gray-300 rounded-lg bg-gray-50">
          <FiCheck className="w-4 h-4 text-green-600" />
          <span className="text-sm text-gray-700 flex-1 truncate">{fileName}</span>
          <button
            type="button"
            onClick={() => {
              setValue("");
              setFileName("");
            }}
            className="text-gray-400 hover:text-red-600 transition-colors"
          >
            <FiX className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <>
          <label
            htmlFor={field.id}
            className={`flex items-center justify-center gap-2 w-full px-4 py-3 bg-yellow-400 text-black rounded-lg cursor-pointer hover:bg-yellow-500 transition-colors font-medium ${
              showError ? "border-2 border-red-500" : ""
            }`}
          >
            <FiUpload className="w-4 h-4" />
            <span>{t("resume_upload")}</span>
          </label>
          <p className="text-xs text-gray-500 mt-2">Upload a PDF file below 5.00 MB.</p>
        </>
      )}
    </div>
  );
}
